import apiClient from './apiClient';

export interface DashboardStats {
    totalSalesToday: number;
    appointmentsTodayCount: number;
    activeClientsCount: number;
    staffEfficiency: number;
}

export const statsApi = {
    getDashboardStats: async (salonId: string): Promise<DashboardStats> => {
        const response = await apiClient.get<DashboardStats>(`/stats/dashboard`, {
            params: { salonId }
        });
        return response.data;
    },
};
